(function () {
  if (window.CustomNecklace) return;

  /* ===============================
     INTERNAL STATE (Single Source)
  =============================== */

  var state = {
    name: "",
    language: "",
    font: "",
    accent: "",
    position: "",
    notes: ""
  };

  var listeners = [];
  var isInternalSync = false;

  /* ===============================
     HELPERS
  =============================== */

  function normalizeLanguage(lang) {
    return (lang || "")
      .toString()
      .trim()
      .toLowerCase();
  }

  function getFontSelect() {
    return document.getElementById("font-style");
  }

  function optionMatchesLanguage(optionEl, language) {
    if (!optionEl || !optionEl.dataset) return false;

    var optLang = normalizeLanguage(optionEl.dataset.language);
    var stateLang = normalizeLanguage(language);

    if (!optLang || !stateLang) return false;

    return optLang === stateLang;
  }

  /* ===============================
     FONT FILTERING (STRICT)
  =============================== */

  function applyFontFiltering(language) {
    var fontSelect = getFontSelect();
    if (!fontSelect) return;

    var lang = normalizeLanguage(language);
    if (!lang) return;

    var options = Array.prototype.slice.call(fontSelect.options || []);
    if (!options.length) return;

    var firstValidOption = null;

    options.forEach(function (opt) {
      var isPlaceholder = !opt.value;

      if (isPlaceholder) {
        opt.hidden = false;
        opt.disabled = false;
        opt.style.display = "";
        return;
      }

      var isValid = optionMatchesLanguage(opt, lang);

      opt.hidden = !isValid;
      opt.disabled = !isValid;
      opt.style.display = isValid ? "" : "none";

      if (isValid && !firstValidOption) {
        firstValidOption = opt;
      }
    });

    // Force-correct font if current selection is invalid
    var selectedOption =
      fontSelect.options[fontSelect.selectedIndex] || null;

    var selectionIsValid =
      selectedOption &&
      !selectedOption.disabled &&
      !selectedOption.hidden &&
      selectedOption.style.display !== "none";

    if (!selectionIsValid && firstValidOption) {
      fontSelect.value = firstValidOption.value;

      if (!isInternalSync) {
        isInternalSync = true;
        window.CustomNecklace.set("font", firstValidOption.value);
        isInternalSync = false;
      }
    }
  }

  /* ===============================
     NOTIFY (State → Outputs)
  =============================== */

  function notify() {
    // Enforce UI constraints on every state change
    applyFontFiltering(state.language);

    listeners.forEach(function (fn) {
      try {
        fn(state);
      } catch (e) {}
    });
  }

  /* ===============================
     PUBLIC API
  =============================== */

  window.CustomNecklace = {
    init: function () {
      var nameInput = document.querySelector(
        'input[name="properties[Custom Name]"]'
      );
      var languageInput = document.getElementById("language-value");
      var fontSelect = getFontSelect();

      // AL FANAN FIX 2026-09-04 — read the accent, position and notes controls at
      // load, exactly as the font select is read above.
      //
      // Neither #shape-option nor #shape-position has a placeholder option, so the
      // browser pre-selects the first one. The shopper sees a real value on screen
      // ("None (Classic Name Only)", "Start of Name") but state.accent and
      // state.position stayed "", so custom-necklace-sync.js mirrored empty strings
      // into the hidden fields and the order recorded nothing. Only a shopper who
      // actively CHANGED a dropdown was ever captured.
      //
      // Confirmed on live order AF1443 (2026-07-17): Custom Name "Lola" and Font
      // Style recorded, Design Accent and Shape Position both empty, on a product
      // carrying accent_mode = optional so both selects were on the page.
      //
      // #custom-notes is read too. It is empty by default, but browsers restore
      // form values on back-navigation and state should reflect what is on screen.
      //
      // See project doc 12.
      var accentSelect = document.getElementById("shape-option");
      var positionSelect = document.getElementById("shape-position");
      var notesField = document.getElementById("custom-notes");

      if (nameInput) state.name = nameInput.value || "";
      if (languageInput) state.language = languageInput.value || "";
      if (fontSelect) state.font = fontSelect.value || "";
      if (accentSelect) state.accent = accentSelect.value || "";
      if (positionSelect) state.position = positionSelect.value || "";
      if (notesField) state.notes = notesField.value || "";

      notify();
    },

    set: function (key, value) {
      if (state[key] === value) return;
      state[key] = value;
      notify();
    },

    get: function () {
      return Object.assign({}, state);
    },

    onChange: function (fn) {
      listeners.push(fn);
    }
  };

  /* ===============================
     EVENT DELEGATION (Expanse-safe)
  =============================== */

  document.addEventListener("input", function (e) {
    if (e.target.name === "properties[Custom Name]") {
      window.CustomNecklace.set("name", e.target.value || "");
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target.id === "font-style") {
      window.CustomNecklace.set("font", e.target.value || "");
    }

    if (e.target.id === "shape-option") {
      window.CustomNecklace.set("accent", e.target.value || "");
    }

    if (e.target.id === "shape-position") {
      window.CustomNecklace.set("position", e.target.value || "");
    }

    if (e.target.id === "custom-notes") {
      window.CustomNecklace.set("notes", e.target.value || "");
    }

    if (e.target.id === "language-switch") {
      var hiddenLang = document.getElementById("language-value");
      if (!hiddenLang) return;

      var defaultLang = hiddenLang.dataset.default || "English";
      var altLang = e.target.dataset.altLanguage;

      hiddenLang.value = e.target.checked ? altLang : defaultLang;

      // Language drives font availability
      window.CustomNecklace.set("language", hiddenLang.value);
    }
  });

  /* ===============================
     INIT
  =============================== */

  document.addEventListener("DOMContentLoaded", function () {
    window.CustomNecklace.init();
  });
})();
